import { TabEnumFe } from "@intelligems/ig-types/fe-only/experiences";

export const TabEnumToUserFacingName: Record<TabEnumFe, string> = {
  [TabEnumFe.TEST_GROUPS]: "Test Groups",
  [TabEnumFe.MODS]: "Modifications",
  [TabEnumFe.PREVIEW]: "Preview",
  [TabEnumFe.ANALYTICS]: "Results",
  [TabEnumFe.CONFIGURE_ANALYTICS]: "Configure Analytics",
  [TabEnumFe.TARGETING]: "Targeting",
};
